import { sd } from "@sd/lib/sdPaths";
import { buildTicketDetailPath } from "@sd/lib/ticketDetailPath";

export const ADMIN_TICKET_ID_QUERY = "ticket";

export function buildAdminTicketViewPath(
  ticketId: string,
  options?: { returnTo?: string }
): string {
  return buildTicketDetailPath(ticketId, {
    returnTo: options?.returnTo ?? sd("admin/tickets"),
  });
}

export function parseAdminTicketIdFromSearchParams(
  searchParams: URLSearchParams
): string | null {
  const id = searchParams.get(ADMIN_TICKET_ID_QUERY)?.trim();
  return id || null;
}

export function ticketIdFromDashboardRow(
  row: Record<string, unknown>
): string | null {
  const id = String(row.id ?? row.ticket_id ?? row.pk ?? "").trim();
  return id || null;
}
